import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const LensesPerBoxText = ({ lensesPerBox  })=>{
    let lensesPerBoxNumber = lensesPerBox;
    if (typeof lensesPerBox === 'string') {
        lensesPerBoxNumber = Number(lensesPerBox);
    }
    const { getLabel  } = useIntl();
    const labels = {
        perBox: getLabel('products.perBox'),
        unit: lensesPerBoxNumber === 1 ? getLabel('products.unit.contactLens') : getLabel('products.unit.contactLenses')
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, `${lensesPerBox} ${labels.unit} ${labels.perBox}`);
};

export { LensesPerBoxText };
//# sourceMappingURL=LensesPerBoxText.js.map
